import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-787">
      <div className="max-w-4xl mx-auto px-6" data-id="element-788">
        <SectionHeading title="Muncești mult, dar banii tot nu ajung?" data-id="element-789" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-790">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-791">
            <p className="font-bold text-xl text-brand-text" data-id="element-792">
              Câștigi bani, dar parcă nu reușești să îi păstrezi.
            </p>
            <p data-id="element-793">
              Oricât ai munci, la finalul lunii e același sentiment de neajuns.
              Te uiți la alții care par să atragă bani ușor și te întrebi ce fac
              ei diferit. Poate te simți vinovată când cheltuiești, poate eviți
              să te uiți la situația financiară reală, poate pur și simplu ai o
              frică constantă legată de bani pe care nu ți-o poți explica.
            </p>
            <p data-id="element-794">
              Și cel mai greu lucru e că acest tipar nu se oprește de la sine.
              Cu cât amâni, cu atât frica crește, stresul se adâncește și
              relația ta cu banii devine tot mai tensionată. Nu e vorba de cât
              câștigi. E vorba de ce crezi despre bani la un nivel pe care nici
              nu îl conștientizezi.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-795">
              <p className="font-medium text-brand-text italic" data-id="element-796">
                Cursul Magnet pentru Bani te ghidează pas cu pas să înțelegi ce
                sunt banii cu adevărat, să identifici credințele din
                subconștient care te sabotează financiar și să construiești o
                relație nouă cu banii, bazată pe încredere, recunoștință și
                abundență. Nu e un curs de investiții. E cursul care schimbă
                ceea ce simți și crezi despre bani, ca banii să înceapă să vină
                spre tine.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-797">
          <CTAButton data-id="element-798" />
        </motion.div>
      </div>
    </section>;
}